export default "__VITE_ASSET__D_QRy1r9__"